const foreignerRouter = {
  path: '/foreigner',
  component: () => import('@/layout'),
  children: [
    {
      path: '', // 外国人主页
      name: 'Foreigner',
      component: () => import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner')
    },
    {
      path: 'service', // 服务主页
      name: 'service',
      component: () => import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/work.vue'),
      children: [
        {
          path: 'workdetail/:isGov/:id',
          name: 'WorkDetail',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/work-detail.vue'),
          meta: { crumb_1: '服务事项' }
        },
        {
          path: 'booking',
          name: 'WorkBooking',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/work-booking.vue'),
          meta: {}
        },
        {
          path: 'submitbooking/:id/:parent_id/:isGov',
          name: 'SubmitBooking',
          component: () =>
            import(
              /* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/submit-booking.vue'
            ),
          meta: { crumb_1: '预约代办' }
        },
        {
          path: 'credit',
          name: 'WorkCredit',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/work-credit.vue'),
          meta: { crumb_1: '信用信息' }
        },
        {
          path: 'property/:id',
          name: 'Property',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/property.vue'),
          meta: { crumb_1: '物业服务' }
        },
        {
          path: 'translate/:id',
          name: 'Translate',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/translate.vue'),
          meta: { crumb_1: '翻译服务' }
        },
        {
          path: 'lease/:id',
          name: 'Lease',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/lease.vue'),
          meta: { crumb_1: '汽车租赁' }
        },
        {
          path: 'law/:id',
          name: 'Law',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/law.vue'),
          meta: { crumb_1: '法律服务' }
        },
        {
          path: 'company/:id',
          name: 'Company',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/company.vue'),
          meta: { crumb_1: '公司注册' }
        },
        {
          path: 'inspection/:id',
          name: 'Inspection',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/inspection.vue'),
          meta: { crumb_1: '商品检测认证' }
        },
        {
          path: 'finance/:id',
          name: 'Finance',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/finance.vue'),
          meta: { crumb_1: '财税服务' }
        },
        {
          path: 'conference/:id',
          name: 'Conference',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/conference.vue'),
          meta: { crumb_1: '会务服务' }
        },
        {
          path: 'trade/:id',
          name: 'Trade',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/trade.vue'),
          meta: { crumb_1: '贸易全流程' }
        },
        {
          path: 'business/:id',
          name: 'Business',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/business.vue'),
          meta: { crumb_1: '商务考察' }
        },
        {
          path: 'supply/:id',
          name: 'Supply',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/supply.vue'),
          meta: { crumb_1: '供应链金融' }
        },
        {
          path: 'brand/:id',
          name: 'Brand',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/brand.vue'),
          meta: { crumb_1: '品牌培育服务' }
        },
        {
          path: 'platform/:id',
          name: 'Platform',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/platform.vue'),
          meta: { crumb_1: '平台入驻' }
        },
        {
          path: 'government',
          name: 'Government',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/government.vue'),
          meta: { crumb_1: '政务代办' }
        },
        {
          path: 'orderlist',
          name: 'OrderList',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/order/list.vue'),
          meta: { crumb_1: '义信购订单' }
        },
        {
          path: 'orderdetail/:id',
          name: 'OrderDetail',
          component: () =>
            import(/* webpackChunkName: "foreigner" */ '@/pages/foreigner/pages/order/detail.vue'),
          meta: { crumb_1: '义信购订单', crumb_2: '订单详情' }
        }
      ]
    }
  ]
}
export default foreignerRouter
